__turbopack_context__.v({
  "code": "IndentContent-module__GXd1qq__code",
  "codeBlock": "IndentContent-module__GXd1qq__codeBlock",
  "container": "IndentContent-module__GXd1qq__container",
  "expanded": "IndentContent-module__GXd1qq__expanded",
  "toggle": "IndentContent-module__GXd1qq__toggle",
});
